import { withDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiPopover']} */
const overwrite = {}

export const MuiPopover = withDisablePortal(overwrite)
